module.exports = __webpack_public_path__ + "img/byte.03f266f3.jpg";